window.players = window.players || {};

function onPlayerStateChange(event) {
    const player = event.target;
    const $iframe = jQuery(player.getIframe());
    const targetOverlay = $iframe.data('target-overlay');

    switch (event.data) {
        case YT.PlayerState.PLAYING:
            jQuery('.' + targetOverlay).fadeOut(200);
            break;
        case YT.PlayerState.PAUSED:
            jQuery('.' + targetOverlay).fadeIn(200);
            break;
        case YT.PlayerState.ENDED:
            const vid = player.getVideoData().video_id;
            // reload video but stop immediately → restores thumbnail
            player.loadVideoById({ videoId: vid, startSeconds: 0 });
            player.stopVideo();
            jQuery('.' + targetOverlay).fadeIn(200);
            break;
        case YT.PlayerState.UNSTARTED:
            jQuery('.' + targetOverlay).fadeIn(200);
            break;
    }
}

jQuery(document).ready(function($){

    // --- Video Overlay & Buttons --- //
    function hideOverlay(video) { const overlayClass = $(video).data("target-overlay"); $("." + overlayClass).fadeOut(200); } 
    function showOverlay(video) { const overlayClass = $(video).data("target-overlay"); $("." + overlayClass).fadeIn(200); }

    function initVideoState(video) {
        const $video = $(video); 
        const wrapper = $video.closest(".team-fancybox__media");
        const playBtn = wrapper.find(".btn-custom-play"); 
        const pauseBtn = wrapper.find(".btn-custom-pause");
        const poster = $video.data('poster');

        playBtn.show(); 
        pauseBtn.hide().removeClass("show"); 
        showOverlay(video); 
        
        video.onplay = function() { 
            hideOverlay(video); 
            playBtn.hide(); 
            pauseBtn.show().addClass("show"); 
            video.setAttribute("controls", "controls"); 

            // remove poster while playing
            if (poster) {
                $video.removeAttr('poster');
            }
        }; 

        video.onpause = function() { 
            if (video.seeking) return;
            playBtn.show(); 
            pauseBtn.hide().removeClass("show"); 
            showOverlay(video); 
            video.removeAttribute("controls"); 
        }; 
        
        video.onended = function(e) { 
            e.stopPropagation();
            playBtn.show(); 
            pauseBtn.hide().removeClass("show"); 
            showOverlay(video); 

            video.removeAttribute("controls"); 

            if (poster) {
                video.pause();
                video.currentTime = 0;
                $video.attr('poster', poster);
                video.load();
            }
        }; 
        
        playBtn.off("click touchstart").on("click touchstart", function(e) { 
            e.stopPropagation(); 
            e.preventDefault();
            video.play().catch(() => {}); 
        }); 

        pauseBtn.off("click touchstart").on("click touchstart", function(e) { 
            e.stopPropagation(); 
            e.preventDefault();
            video.pause(); 
        });
    }

    function stopVideos($container) { 
        $container.find('video.expertise-video').not('.slick-cloned').each(function() {
            const video = this;
            const wrapper = $(video).closest(".team-fancybox__media");
            const playBtn = wrapper.find(".btn-custom-play");
            const pauseBtn = wrapper.find(".btn-custom-pause");

            video.removeAttribute("controls");

            video.pause();
            video.currentTime = 0;

            $video = $(video);
            const poster = $video.data('poster');

            if (poster) {
                $video.attr('poster', poster);
                video.load(); // <-- this forces poster to display
            }

            // Reset UI
            showOverlay(video);
            playBtn.show().attr("data-state", "play");
            pauseBtn.hide().removeClass("show"); // hide pause/stop button
        });
    }

    function stopYouTube($container) { 
        $container.find('iframe[class*="expertise-media-team"]').each(function() { 
            const playerId = $(this).attr('id'); 
            if (window.players[playerId]) { 
                window.players[playerId].stopVideo(); 
            } 
        }); 
    }

    $('[data-fancybox="expertises"]').fancybox({
        animationEffect: "slide",
        animationDuration: 300,
        closeClickOutside: true,
        buttons: ["close", "thumbs"],
        keyboard: false,
        protect: true,
        autoFocus: false,
        loop: false,
        slideShow : false,
        trapFocus : false, 
        video: {
            autoStart: false
        },

        beforeShow: function(instance, current) {
            stopVideos($(current.src)); 
            stopYouTube($(current.src)); 
        },

        afterShow: function (instance, current) {
            const $content = $(current.src);

            // Reinitialize carousels
            $content.find('.team-fancybox__team_carousel, .team-fancybox__workplace_carousel') .slick('setPosition');

            // Initialize YouTube
            $content.find('iframe[class*="expertise-media-team"]').each(function() { 
                const $iframe = $(this); 
                const id = $iframe.attr('id') || 'ytplayer-' + Math.random().toString(36).substring(2, 9); 
                $iframe.attr('id', id); 
                if (window.players[id]) { 
                    try { 
                        window.players[id].stopVideo(); 
                        delete window.players[id]; 
                    } catch(e){ 
                        console.warn("YT cleanup failed", e);
                    } 
                } 
                
                window.players[id] = new YT.Player(id, { events: { onStateChange: onPlayerStateChange } }); 
            });

            // Initialize HTML5 videos
            $content.find('video.expertise-video').not('.slick-cloned').each(function() {
                initVideoState(this);
                // Also stop Fancybox auto-next
                $(this).off('ended.fancybox').on('ended.fancybox', function(e) {
                    e.stopImmediatePropagation();
                });
            });
        },

        beforeClose: function (instance, current) {
            stopVideos($(current.src));
            stopYouTube($(current.src));
        }
    });

    // --- Stop videos on carousel slide change --- //
    $('.team-fancybox__team_carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        const $currentSlide = $(slick.$slides.get(currentSlide));
        const $nextSlide = $(slick.$slides.get(nextSlide));

        stopVideos($currentSlide);
        stopYouTube($currentSlide);

        // Show overlay on next slide
        $nextSlide.find('video.expertise-video').not('.slick-cloned').each(function() {
            showOverlay(this);
        });
    });


    // --- Other Fancybox Groups (Workplaces) --- //
    ['America','Europe','Asia-pacific'].forEach(region => { 
        $('[data-fancybox="workplaces-'+region+'"]').fancybox({ 
            animationEffect: "slide", 
            animationDuration: 300, 
            closeClickOutside: true, 
            buttons: ["close", "thumbs"], 
            
            afterShow: function(instance, current){ 
                $(current.src).find('.team-fancybox__carousel').slick('setPosition'); 
            } 
        });
    });
    

    $('.js-workplace-link').on('click', function (e) {
        e.preventDefault();

        const $clicked = $(this);
        const region = $clicked.data("region");

        // 1 Switch to the Workplace tab
        $('.tabs__item').removeClass('is-active');
        $('.tabs__item[data-tab="workplace"]').addClass('is-active');
        $('.tabs__panel').removeClass('is-active');
        $('#workplace').addClass('is-active');



        // 3 Collect all workplace cards for this region
        const selector = '[data-fancybox="workplaces-' + region + '"]';
        const $groupCards = $(selector).not('.slick-cloned');;

        if (!$groupCards.length) {
            console.warn('No workplace cards found for region:', region);
            return;
        }

        // 4 Build Fancybox items array
        const items = [];
        let startIndex = 0;

        $groupCards.each(function(i) {
            const $el = $(this);
            const src = $el.data('src') || $el.attr('href'); // inline target
            
            if (!src) return;

            items.push({ src: src, type: 'inline' });

            // Detect the clicked element
            if ($el.data("src") === $clicked.data("src")) {
                startIndex = i;
            }
        });

        if (!items.length) return;

        // 5 Close any currently open Fancybox (expertise) first
        $.fancybox.close();
        
        // 6 Open the Workplace Fancybox
        setTimeout(() => {
            $.fancybox.open(items, {
                loop: true,
                animationEffect: "slide",
                animationDuration: 200,
                closeClickOutside: true,
                buttons: ["close", "arrowLeft", "arrowRight"],
                index: startIndex,

                afterShow: function(instance, current) {
                    // Reinitialize slick inside currently visible content
                    $(current.src).find('.team-fancybox__carousel').slick('setPosition');
                    $(current.src).find('.team-fancybox__team_carousel').slick('setPosition');
                    $(current.src).find('.team-fancybox__workplace_carousel').slick('setPosition');
                }
            });
        }, 50); // small timeout for smoother transition
    });


    $('.tabs__item').on('click', function () {
        const tabId = $(this).data('tab');

        // Update nav active state
        $('.tabs__item').removeClass('is-active');
        $(this).addClass('is-active');

        // Update panels
        $('.tabs__panel').removeClass('is-active');
        $('#' + tabId).addClass('is-active');
    });

    const $lightbox = $('#lightbox');
    const $wrapper = $('.lightbox__img-wrapper');
    let currentIndex = 0;
    let $images = null;

    // Open Lightbox
    $(".show-lightbox").on('click', function() {
        const boxID = $(this).data('target-box');
        $images = $('#' + boxID + ' .team-fancybox__image');
        let targetIndex = parseInt($(this).data('target-index'), 10) || 0;
        
        // Fix for single image or invalid index
        if (targetIndex >= $images.length) {
            targetIndex = 0;
        }
        currentIndex = targetIndex;

        showImage(currentIndex, $images);
        $lightbox.addClass('is-active');

        // Hide navigation if only one image
        if ($images.length <= 1) {
            $('.lightbox__nav--next, .lightbox__nav--prev').hide();
        } else {
            $('.lightbox__nav--next, .lightbox__nav--prev').show();
        }
    });

    function showImage(index, $images) {
        
        const src = $images.eq(index).attr('src');
        if (!src) {
            console.warn("⚠️ No image source found at index:", index);
            return;
        }
        $wrapper.html(`<img src="${src}" class="lightbox__img is-visible">`);
    }

    function closeLightbox() {
        $lightbox.removeClass('is-active');
    }

    // Close on click
    $('.lightbox__close, #lightbox').on('click', function(e) {
        if (e.target.id === 'lightbox' || e.target.classList.contains('lightbox__close')) {
            closeLightbox();
        }
    });

    // Change image with transition
    function changeImage(nextIndex, direction, $images) {
        const currentImg = $wrapper.find('.lightbox__img');
        const nextSrc = $images.eq(nextIndex).attr('src');
        if (!nextSrc) return;

        const nextImg = $('<img>')
            .attr('src', nextSrc)
            .addClass('lightbox__img');

        if (direction === 'next') nextImg.addClass('slide-in-right');
        else nextImg.addClass('slide-in-left');

        $wrapper.append(nextImg);

        setTimeout(() => {
            currentImg.addClass(direction === 'next' ? 'slide-from-left' : 'slide-from-right');
            nextImg.removeClass(direction === 'next' ? 'slide-in-right' : 'slide-in-left')
                .addClass('is-visible');
        }, 20);

        setTimeout(() => currentImg.remove(), 600);
    }

    $('.lightbox__nav--next').on('click', function(e) {
        e.stopPropagation();
        if ($images.length <= 1) return;
        const nextIndex = (currentIndex + 1) % $images.length;
        changeImage(nextIndex, 'next', $images);
        currentIndex = nextIndex;
    });

    $('.lightbox__nav--prev').on('click', function(e) {
        e.stopPropagation();
        if ($images.length <= 1) return;
        const prevIndex = (currentIndex - 1 + $images.length) % $images.length;
        changeImage(prevIndex, 'prev', $images);
        currentIndex = prevIndex;
    });

    // Keyboard controls
    $(document).on('keydown', function(e) {
        if (!$lightbox.hasClass('is-active')) return;

        if (e.key === 'ArrowRight' && $images.length > 1) $('.lightbox__nav--next').click();
        if (e.key === 'ArrowLeft' && $images.length > 1) $('.lightbox__nav--prev').click();
        if (e.key === 'Escape') closeLightbox();
    });

    // Leadership video play/pause functionality
    $('.team-grid__item-content.video').each(function() {
        const $container = $(this);
        const $video = $container.find('video')[0];
        const $playBtn = $container.find('.video-play-btn');

        if (!$video || !$playBtn.length) return;

        // Play button click
        $playBtn.on('click', function(e) {
            e.stopPropagation();
            $video.play();
            $playBtn.addClass('hidden');
        });

        // Video click - pause and show play button
        $($video).on('click', function(e) {
            e.stopPropagation();
            if (!$video.paused) {
                $video.pause();
                $playBtn.removeClass('hidden');
            }
        });

        // Video ended - show play button
        $($video).on('ended', function() {
            $playBtn.removeClass('hidden');
        });

        // Video paused - show play button
        $($video).on('pause', function() {
            $playBtn.removeClass('hidden');
        });

        // Video playing - hide play button
        $($video).on('play', function() {
            $playBtn.addClass('hidden');
        });
    });
});